import { render, staticRenderFns } from "./payment-page.vue?vue&type=template&id=0b11f2cf&scoped=true"
import script from "./payment-page.vue?vue&type=script&lang=js"
export * from "./payment-page.vue?vue&type=script&lang=js"
import style0 from "./payment-page.vue?vue&type=style&index=0&id=0b11f2cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11f2cf",
  null
  
)

export default component.exports